<script setup lang="ts">
import type { IAffiliatesTableDataResponseRecord } from '@modules/affiliates-approved/types';
import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import { useAffiliatesTranslate } from '@modules/affiliates-approved/composables';
import { useChangeAffiliateStatusMutation } from '@modules/affiliates-approved/mutations';
import { useConfirmDialogs } from '@modules/core/composables/dialogs';

const props = defineProps<{ listItem: IAffiliatesTableDataResponseRecord }>();

const { translate } = useAffiliatesTranslate();
const { confirmDelete } = useConfirmDialogs();

const {
  isLoading: isChangingStatusLoading,
  mutateAsync: changeAffiliateStatus,
} = useChangeAffiliateStatusMutation();

function changeStatus(): void {
  void changeAffiliateStatus(props.listItem.id);
}

function changeStatusConfirm(event: MouseEvent): void {
  const goal = props.listItem.status === 'blocked'
    ? translate('CHANGE_STATUS_GOAL_UNBLOCK')
    : translate('CHANGE_STATUS_GOAL_BLOCK');

  const message = `
    ${translate('CHANGE_STATUS_STATUS_QUESTION')}
    ${goal}
    ${translate('CHANGE_STATUS_STATUS_QUESTION_PARTNER')}
    ${props.listItem.name || ''}?
  `;

  confirmDelete({
    event,
    message,
    header: translate('CHANGE_STATUS_GOAL_TITLE'),
    acceptLabel: translate('CHANGE_STATUS_ANSWER_YES'),
    rejectLabel: translate('CHANGE_STATUS_ANSWER_NO'),
    accept: changeStatus,
  });
}
</script>

<template>
  <VIconButton v-data-qa-auto-id="'VChangeAffiliateStatus'"
    v-if="listItem.status"
    :icon="`pi-${listItem.status === 'blocked' ? 'lock' : 'lock-open'}`"
    :loading="isChangingStatusLoading"
    @click="changeStatusConfirm($event)"
  />
</template>
